import config from 'src/js/modules/config';

const isB2CUser = (store) => {
  const state = store.getState();
  return config.selectors.getIsB2C(state);
};

export default isB2CUser;
